<!-- 实时交易数据 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "../../../commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCodeList": ["2KKN885S"],
                "number": 1
            },
            responseCode: {
                    "data": {
                        "recordList": [
                            {
                                "carCode": "京Y19746",
                                "parkId": "d43770c2-1809-436f-a3d2-d5c52d6347c6",
                                "parkName": "昌俊停车场",
                                "payMode": "CASH",
                                "payModeIndex": 1,
                                "payModeString": "现金",
                                "payTime": 28912000,
                                "payTimeStr": "16:01:52",
                                "realValue": 0.01
                            }
                        ]
                    },
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                }
                ,infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取实时交易数据",
                t_url: this.commonUrls.test+"dealRealTime",
                p_url: this.commonUrls.prod+"dealRealTime",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodeList', info2: '是', info3: 'String[]', info4: '停车场编码数组' },
                        { info1: 'number', info2: '是', info3: 'Long', info4: '数据条数' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'payTime', info2: '是', info3: 'long', info4: '支付时间时间戳,HH:mm:ss' },
                        { info1: 'payTimeStr', info2: '是', info3: 'String', info4: '支付时间,HH:mm:ss' },
                        { info1: 'realValue', info2: '是', info3: 'Decimal', info4: '实付金额' },
                        { info1: 'payMode', info2: '是', info3: 'Integer', info4: '支付方式' },
                        { info1: 'payModeIndex', info2: '是', info3: 'Integer', info4: '支付方式序号，详情见附录' },
                        { info1: 'payModeString', info2: '是', info3: 'String', info4: '支付方式描述' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/dataAnalysis/dealRealTime.vue